import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import './Pages.css';

export const NotFound: React.FC = () => {
  return (
    <div className="ns-page">
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '60vh',
        textAlign: 'center',
        padding: '40px 20px'
      }}>
        <h1 style={{ fontSize: '72px', margin: '0 0 20px 0', color: '#0ea5e9' }}>404</h1>
        <h2 style={{ fontSize: '32px', margin: '0 0 16px 0', color: '#0f172a' }}>
          Página não encontrada
        </h2>
        <p style={{ fontSize: '16px', color: '#64748b', margin: '0 0 32px 0', maxWidth: '500px' }}>
          A página que você está procurando não existe ou foi movida.
        </p>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
          <Link to="/">
            <Button variant="secondary">Voltar para início</Button>
          </Link>
          <Link to="/dashboard">
            <Button>Ir para Dashboard</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

